import { RouteConfig } from 'vue-router';
// import * as welcome from './components/welcome/_routes';
import * as main from './views/main/_routes';
import { NavigationGuard } from 'vue-router';

import PageNotFoundComponent from './views/page-not-found.vue';
import ErrorComponent from './views/error.vue';

export const RouteNames = {
    // ...welcome.RouteNames,
    ...main.RouteNames,
    error: 'error',
    notFound: 'not-found'
};

const QUERYSTRING_ORIGIN_PATH = 'originPath';

// eslint-disable-next-line consistent-return
const errorGuard: NavigationGuard = (to, from, next) => {
    if (!to.params.error) {
        return next('/');
    }

    if (!to.query[QUERYSTRING_ORIGIN_PATH]) {
        to.query[QUERYSTRING_ORIGIN_PATH] = to.params.to || from.fullPath;
        return next({ name: RouteNames.error, query: to.query, params: to.params });
    }
    next();
};

// Routes resolved in order
export const Routes: RouteConfig[] = [
    main.Route,
    // welcome.Route,
    { path: '/error', name: RouteNames.error, component: ErrorComponent, beforeEnter: errorGuard, props: true },
    { path: '*', name: RouteNames.notFound, component: PageNotFoundComponent },
];